// ── Period + utilisation maths ──────────────────────────────────────────────
// Extracted verbatim from the original Labour / LabourAnnual components so the
// two pages can never drift apart on how utilisation is calculated.

/** Non-billable projects that are treated as unavailability, not as work. */
export const NB_PROJECT_CONFIG = {
  "TS-ANL-02": { label: "Annual Leave",    bucket: "deduction" },
  "TS-VAC-02": { label: "Public Holidays", bucket: "deduction" },
  "TS-SIC-02": { label: "Sick Days",       bucket: "deduction" },
};

export const getBucket = (projectCode) =>
  NB_PROJECT_CONFIG[projectCode]?.bucket || "indirect";

export const HOURS_PER_DAY = 7.5;

/** Leave + public holidays come off the denominator; sick days do not. */
export const DENOMINATOR_DEDUCTION_PROJECTS = new Set(["TS-VAC-02", "TS-ANL-02"]);

/** Newest period first. Periods are "MM/YYYY". */
export const sortPeriods = (arr) =>
  [...arr].sort((a, b) => {
    const [ma, ya] = a.split("/");
    const [mb, yb] = b.split("/");
    return ya !== yb ? parseInt(yb, 10) - parseInt(ya, 10) : parseInt(mb, 10) - parseInt(ma, 10);
  });

export const workingDaysInPeriod = (period) => {
  if (!period) return 20;
  const [mm, yyyy] = period.split("/");
  const month = parseInt(mm, 10) - 1;
  const year = parseInt(yyyy, 10);
  const days = new Date(year, month + 1, 0).getDate();
  let count = 0;
  for (let d = 1; d <= days; d++) {
    const dow = new Date(year, month, d).getDay();
    if (dow !== 0 && dow !== 6) count++;
  }
  return count;
};

export const availableHours = (period, deductionHours = 0) =>
  Math.max(0, workingDaysInPeriod(period) * HOURS_PER_DAY - deductionHours);

export const calcUtil = (direct, avail) => (avail > 0 ? (direct / avail) * 100 : 0);

/** Which heat band a utilisation percentage falls into (Dashboard summary). */
export const heatClass = (util) => {
  const u = parseFloat(util) || 0;
  if (u >= 90) return "heat-a";
  if (u >= 75) return "heat-b";
  if (u >= 60) return "heat-c";
  return "heat-d";
};

/** Split one breakdown row into direct / indirect / unavailable hours. */
export const classifyRow = (r) => {
  const h = parseFloat(r.hours || 0);
  if (r.labor_code !== "NB") return { direct: h, indirect: 0, deduction: 0, total: h };
  if (getBucket(r.project_code) === "deduction")
    return { direct: 0, indirect: 0, deduction: h, total: h };
  return { direct: 0, indirect: h, deduction: 0, total: h };
};
